/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/space-before-function-paren */
function wholeNumber(message) {
    return this.test('wholeNumber', '', function (value) {
        if (typeof value === 'undefined' || value === null)
            return true;
        // check for posetive integer
        var wholeNumber = Number.isInteger(value) && value >= 0;
        if (!wholeNumber) {
            return this.createError({
                message: message !== null && message !== void 0 ? message : "".concat(this.path, " must be a whole number")
            });
        }
        else {
            return true;
        }
    });
}
function decimal(message) {
    return this.test('decimal', '', function (value) {
        if (typeof value === 'undefined')
            return true;
        // check for posetive integer
        var isDecimal = value >= 0;
        if (!isDecimal) {
            return this.createError({
                message: message !== null && message !== void 0 ? message : "".concat(this.path, " must be a decimal")
            });
        }
        else {
            return true;
        }
    });
}
function englishTestScore(examKey, isValid, message) {
    return this.test('englishTestScore', '', function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (typeof value !== 'number')
            return true;
        var examType = (_c = (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a[examKey]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : (_d = this.parent) === null || _d === void 0 ? void 0 : _d[examKey];
        if (!examType)
            return true;
        if (examType === 'IELTS') {
            var validGrade = (_e = isValid === null || isValid === void 0 ? void 0 : isValid(value, examType)) !== null && _e !== void 0 ? _e : (Number(value) > 0 && Number(value) <= 9);
            if (!validGrade) {
                return this.createError({
                    message: (_f = message === null || message === void 0 ? void 0 : message(examType)) !== null && _f !== void 0 ? _f : 'Please enter between 1 to 9'
                });
            }
        }
        else if (examType === 'DUOLINGO') {
            var validGrade = (_g = isValid === null || isValid === void 0 ? void 0 : isValid(value, examType)) !== null && _g !== void 0 ? _g : (Number(value) >= 10 && Number(value) <= 160);
            if (!validGrade) {
                return this.createError({
                    message: (_h = message === null || message === void 0 ? void 0 : message(examType)) !== null && _h !== void 0 ? _h : 'Please enter between 10 to 160'
                });
            }
        }
        else if (examType === 'PTE') {
            var validGrade = (_j = isValid === null || isValid === void 0 ? void 0 : isValid(value, examType)) !== null && _j !== void 0 ? _j : (Number(value) >= 10 && Number(value) <= 90);
            if (!validGrade) {
                return this.createError({
                    message: (_k = message === null || message === void 0 ? void 0 : message(examType)) !== null && _k !== void 0 ? _k : 'Please enter between 10 to 90'
                });
            }
        }
        else if (examType === 'TOEFL') {
            var validGrade = (_l = isValid === null || isValid === void 0 ? void 0 : isValid(value, examType)) !== null && _l !== void 0 ? _l : (Number(value) > 0 && Number(value) <= 120);
            if (!validGrade) {
                return this.createError({
                    message: (_m = message === null || message === void 0 ? void 0 : message(examType)) !== null && _m !== void 0 ? _m : 'Please enter between 1 to 120'
                });
            }
        }
        return true;
    });
}
function decimalPoints(points, message) {
    return this.test('decimal-points', '', function (value) {
        if (typeof value === 'undefined')
            return true;
        var decimalSeperated = String(value).split('.');
        if (decimalSeperated && Array.isArray(decimalSeperated) && decimalSeperated.length === 2) {
            var decimalPoints_1 = decimalSeperated === null || decimalSeperated === void 0 ? void 0 : decimalSeperated[1];
            if (decimalPoints_1 && String(decimalPoints_1).length > points) {
                return this.createError({
                    message: message !== null && message !== void 0 ? message : "".concat(this.path, " only ").concat(points, " are allowed")
                });
            }
        }
        else {
            return true;
        }
        return true;
    });
}
export { wholeNumber, decimal, englishTestScore, decimalPoints };
//# sourceMappingURL=number.methods.js.map